<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>特殊宝箱配置</span>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="宝箱ID">
              <el-input v-model.number="item.propsId" readonly style="width: 100px;" placeholder="宝箱ID" />
            </el-form-item>
            <el-form-item label="宝箱名称">
              <el-input v-model="item.name" style="width: 150px;" placeholder="宝箱名称" />
            </el-form-item>
            <el-form-item label="卡片数量">
              <el-input v-model.number="item.reward[0].num" style="width: 150px;" placeholder="奖励内容" />
            </el-form-item>
            <el-form-item label="小丑卡兑换数量">
              <el-input v-model.number="item.reward[1].num" style="width: 150px;" placeholder="奖励内容" />
            </el-form-item>
            <el-form-item label="奖励配置">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="langVisibleArr[index].visible = true" />
              <el-dialog :before-close="(d)=>{return handleClose(d, index)}" style="overflow-y: auto" title="奖励配置" width="500px" :visible="langVisibleArr[index].visible">
                <el-form>
                  <el-row v-for="(r,i) in item.reward[2].pro" :key="i">
                    <el-form-item label="数量" style="margin-top: 10px;">
                      <el-input v-model.number="r.num" style="width: 130px;" placeholder="数量" />
                    </el-form-item>
                    <el-form-item label="概率" style="margin-top: 10px;">
                      <el-input v-model.number="r.v" style="width: 130px;" placeholder="概率" />
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;">
                      <el-button v-if="item.reward[2].pro.length > 1" v-permisaction="['config:chest:del']" type="danger" @click="removeReward(index, i)">删除</el-button>
                    </el-form-item>
                  </el-row>
                  <el-form-item>
                    <el-button v-permisaction="['config:chest:add']" type="primary" @click="addReward(index)">+</el-button>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="langVisibleArr[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="langVisibleArr[index].visible = false">确 定</el-button>
                </div>
              </el-dialog>
            </el-form-item>
            <el-form-item label="体力配置">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="weightVisibleArr[index].visible = true" />
              <el-dialog :before-close="(d)=>{return handleWeightClose(d, index)}" style="overflow-y: auto" title="体力配置" width="1800px" :visible="weightVisibleArr[index].visible" @open="openWeight(item.propsId)">
                <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
                  <el-col :span="1.5">
                    <el-upload
                      class="upload-demo"
                      :action="sys_app_logoAction"
                      accept="xlsx"
                      :limit="1"
                      :on-success="(res)=>{return importUploadSuccess(res, item.propsId)}"
                      :headers="headers"
                    >
                      <el-button v-permisaction="['config:chest:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                    </el-upload>
                  </el-col>

                  <el-col :span="1.5">
                    <el-button
                      v-permisaction="['config:chest:export']"
                      type="primary"
                      icon="el-icon-download"
                      size="mini"
                      @click="exportData(item.propsId)"
                    >导出</el-button>
                  </el-col>
                </el-row>
                <el-form>
                  <table>
                    <tr>
                      <td>等级</td>
                      <td v-for="(item, index) in weightHeader" :key="index">权重{{ item }}</td>
                    </tr>
                    <tr v-for="(wr,wi) in weightFormData.reward[3].pro" :key="wi">
                      <td>{{ wr.lv }}</td>
                      <td v-for="(ww, wwi) in wr.weight" :key="wwi">{{ ww.num }}</td>
                    </tr>
                  </table>
                  <!--                  <el-row v-for="(wr,wi) in weightFormData.reward[3].pro" :key="wi">-->
                  <!--                    <el-form-item label="等级" style="margin-top: 10px;border:none">-->
                  <!--                      <el-input v-model.number="wr.lv" size="mini" style="width: 50px;" placeholder="等级" />-->
                  <!--                    </el-form-item>-->
                  <!--                    <el-form-item v-for="(ww, wwi) in wr.weight" :key="wwi" :label="'权重'+ww.v" style="margin-top: 10px;">-->
                  <!--                      <el-input v-model.number="ww.num" size="mini" style="width: 60px;" placeholder="概率" />-->
                  <!--                    </el-form-item>-->
                  <!--                  </el-row>-->
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="weightVisibleArr[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="weightVisibleArr[index].visible = false">确 定</el-button>
                </div>
              </el-dialog>
            </el-form-item>
          </el-row>
          <el-button v-permisaction="['config:chest:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  exportChestWeight,
  getChestCfgList,
  getChestWeight,
  importChestWeight,
  updateChestCfg
} from '@/api/config/chest-cfg'
import { getToken } from '@/utils/auth'
export default {
  name: 'Chest',
  data() {
    return {
      langVisibleArr: [{ visible: false }],
      weightVisibleArr: [{ visible: false }],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      weightTable: [],
      weightData: [],
      formData: [
        {
          'propsId': 0,
          'name': '',
          'reward': [
            {
              num: 0,
              propsId: 17
            }, {
              num: 50,
              propsId: 18
            }, {
              pro: [{
                num: 100,
                v: 1
              }],
              propsId: 14
            }, {
              propsId: 15,
              pro: []
            }, {
              propsId: 8,
              pro: []
            }]
        }
      ],
      weightHeader: [],
      weightFormData: {
        'propsId': 0,
        'name': '',
        'reward': [
          {
            num: 0,
            propsId: 17
          }, {
            num: 50,
            propsId: 18
          }, {
            pro: [{
              num: 100,
              v: 1
            }],
            propsId: 14
          }, {
            propsId: 15,
            pro: []
          }, {
            propsId: 8,
            pro: []
          }]
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClose(d, index) {
      this.langVisibleArr[index].visible = false
    },
    handleWeightClose(d, index) {
      this.weightVisibleArr[index].visible = false
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateChestCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getChestCfgList(this.queryParams).then(res => {
        res.data.forEach((item, index) => {
          this.langVisibleArr.push({
            visible: false
          })
          this.weightVisibleArr.push({
            visible: false
          })
        })
        this.formData = res.data
      })
    },
    addReward(index) {
      this.formData[index].reward[2].pro.push({
        num: 1,
        v: 0
      })
    },
    removeReward(index, zIndex) {
      this.formData[index].reward[2].pro = this.formData[index].reward[2].pro.filter((item, i) => {
        return i !== zIndex
      })
    },
    openWeight(id) {
      this.weightFormData = []
      getChestWeight({ id: id }).then(res => {
        if (res.code === 200) {
          this.weightFormData = res.data
          const pro = res.data.reward[3].pro
          this.weightHeader = []
          pro[0].weight.forEach(item => {
            this.weightHeader.push(item.v)
          })
          pro.forEach((item) => {
            const tempData = []
            tempData.push(item.lv)
            item.weight.forEach((w) => {
              tempData.push(w.num)
            })
            this.weightData.push(tempData)
            console.log(this.weightData)
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData(id) {
      exportChestWeight({ id: id }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response, id) {
      importChestWeight({ data: response.data.path, name: id }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>
<style scoped>
table {
  border-collapse: collapse; /* 合并边框 */
}

td {
  border: 1px solid #ccc; /* 单元格边框样式 */
  padding: 5px; /* 单元格内边距 */
  height: 30px;
  width: 100px;
  text-align: center;
}
</style>

